<template>
  <el-dialog
    top="5vh"
    class="dialog-full-medium"
    width="70%"
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <div v-if="isError">
        <div class="error-text">部分订单付款提交失败，请检查后重新发起</div>
        <jr-table
          size="mini"
          :max-height="250"
          :tableData="errorList"
          :tableColumn="errorTableColumn"
        />
      </div>
      <el-form
        v-else
        :model="ruleForm"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-width="120px"
        label-position="left"
      >
        <!-- 综合/单个(银行/支付宝)发起支付-类型切换 -->
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-tab-pane label="线上支付" name="online" />
        </el-tabs>
        <!-- 线上支付 -->
        <div class="tab-message" v-if="activeName === 'online'">
          <div class="main-cont-item">
            <h2 class="title-text">目标银行账户信息</h2>
            <div class="list-box">
              <jr-table
                size="mini"
                :max-height="250"
                :tableData="list"
                :tableColumn="tableColumn"
                :loading="loading"
              />
              <div class="sum">合计付款金额： {{paymentObj.paymentTotalAmount | toFenThousandsAndFloat}}元</div>
            </div>
          </div>
          <payways-list
            ref="payWaysListRef"
            :paymentInfoNewList="paymentInfoNewList"
            :loading="paymentChannelLoading"
            :paymentObj="paymentObj"
            :payMethodObj="payMethodObj"
            :code.sync="ruleForm.code"
            :channelCode.sync="ruleForm.channelCode"
            @channelCodeChange="channelCodeChange"
            @paymentChannelChange="paymentChannelChange"
          />
        </div>
      </el-form>
    </div>
    <span slot="footer" :class="['dialog-footer', isError ? 'error-footer' : '']">
      <template v-if="$has('FWS-SFKGL-FKD-FKTJ')">
        <el-button @click="handleClose()" :size="formSize">{{isError ? '关闭' : '取消'}}</el-button>
        <el-button
          v-if="!isError"
          type="primary"
          :size="formSize"
          @click="submit()"
          :loading="submitLoading"
        >
          提交
        </el-button>
      </template>
      <el-button v-else @click="handleClose()" :size="formSize">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getBatchAccInfo } from '@/api/receivables';
import operate from '../mixins/operate';
import paywaysList from '@/views/components/payways-list';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: '发起付款',
    },
    paymentNo: {
      type: String,
      default: '',
    },
    paymentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    activeName() {
      this.$refs.ruleForm.resetFields();
    },
  },
  mixins: [operate],
  components: { paywaysList },
  data() {
    return {
      paymentNos: [],
      activeName: 'online',
      isAliPayMode: true,
      ruleForm: {
        code: '',
        paymentChannelNo: '',
        paymentChannelName: '',
        channelCode: '',
      },
      rules: {
        code: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
        ],
        paymentChannelNo: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
        channelCode: [
          { required: true, message: '选择不能为空', trigger: 'change' },
        ],
      },
      list: [],
      loading: false,
      tableColumn: [
        { label: '付款单编号', prop: 'paymentNo' },
        { label: '客户名称', prop: 'businessName' },
        { label: '收款户名', prop: 'bankAccountName' },
        { label: '收款账户', prop: 'bankCardNumber' },
        { label: '收款银行', prop: 'bankName' },
        { label: '支行', prop: 'bankBranchInfo' },
        { label: '金额(元)', prop: 'payAmount', filterName: 'toFenThousandsAndFloat' },
      ],
      errorList: [],
      errorTableColumn: [
        { label: '付款单编号', prop: 'paymentNo' },
        { label: '收款户名', prop: 'bankAccountName' },
        { label: '收款账户', prop: 'bankCardNumber' },
        { label: '收款银行', prop: 'bankName' },
        { label: '支行', prop: 'transAmount' },
        { label: '金额(元)', prop: 'payAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '结果', prop: 'resultMsg' },
      ],
      isError: false,
      paymentInfoList: [],
      payMethodObj: {
        needCode: '',
        payPreorders: [],
        paymentNo: '',
      },
    };
  },
  methods: {
    // tab切换
    handleTabsClick() {
      this.$refs.ruleForm.resetFields();
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('update:paymentNo', '');
      this.$refs.payWaysListRef.clearInterval();
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.ruleForm = {
          code: '',
          paymentChannelNo: '',
          paymentChannelName: '',
          channelCode: '',
        };
        this.paymentInfoList = [];
        this.payMethodObj = {
          needCode: '',
          paymentReqId: '',
          paymentNo: this.paymentNo,
        };
        this.paymentNos = this.paymentNo.split(',');
        this.$refs.ruleForm.resetFields();

        this.getPaymentPaymentPayMethod(this.paymentNo, 1);
        this.getBatchAccInfo();

        this.timeStr = 0;
        this.timer = null;
        this.isFlag = false;
      });
    },
    async getBatchAccInfo() {
      try {
        this.loading = true;
        const res = await getBatchAccInfo({ paymentNos: this.paymentNos });
        this.list = res.data || [];
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // 提交
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.handleOnline(1);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .payment-channel {
    // .el-form-item__content {
    // margin-left: 0 !important;
    // }
    margin-bottom: 0 !important;
    .el-radio {
      display: flex;
      line-height: 20px;
      align-items: center;
      .el-radio__label {
        white-space: break-spaces;
      }
    }
  }
  .el-tabs__header {
    margin: 0;
  }
  .title-text {
    margin-top: 16px;
  }
  .el-button {
    min-width: 64px;
    padding: 8px 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .el-dialog {
    min-width: 400px;
  }
}
.main-cont-item {
  padding-bottom: 16px;
  border-bottom: none;
  margin-bottom: 0;
  h2 {
    font-size: 14px;
  }
  &:last-child {
    padding-bottom: 0px;
  }
}

.tab-message {
  overflow: hidden;
  // max-height: 400px;
  // overflow: auto;
  // overflow-x: hidden;
}

.error-text {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #272728;
  font-size: 18px;
  padding: 20px 0;
}

.error-footer {
  text-align: center;
}

.list-box {
  .sum {
    text-align: right;
    padding-top: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #272728;
  }
}
</style>
